import { useNavigate } from 'react-router-dom'


const useEventCard = () => {

  const displayDay = (date) => {
    return date?.toDateString().split(" ")[2];
  };

  const displayMonth = (date) => {
    return date?.toDateString().split(" ")[1];
  };

  const displayDayForMoData = (date) => {
    date?.split(" ");
    return date?.split(" ")[2];
  };

  const displayMonthForMoData = (date) => {
    date.split(" ");
    return date?.split(" ")[1];
  };

  const navigate = useNavigate()
  const navigateToEvent = (id) => {
      return () => {
          navigate("/events/" + id)
      }
  }

  return {
    displayDay,
    displayMonth,
    navigateToEvent,
    displayDayForMoData,
    displayMonthForMoData
  };
};

export default useEventCard;
